import { db } from "../../firebase/firebase";
import revealData from '../../util/revealData';
import moment from 'moment';

export const getOrdersRequest = async (userId, status) => {
  try {
    let orders = [];
    let raw = [];
    await db.ref(`orders/${userId}`).once('value', snap => {
      orders = snap.val() ? Object.values(snap.val()) : []
    });
    if (orders.length > 0) {
      await orders.forEach(async (order, index) => {
        await db.ref(`users/${order.targetId}`).once('value', async snap => {
          let user = await snap.val();
          let majorId = await user.rol === 'major' ? user.id : order.userId;
          await db.ref(`products/${majorId}/${order.productId}`).once('value', async productsSnap => {
            let product = await { ...productsSnap.val() };
            raw.push({
              ...order,
              userName: user.name,
              productName: product.name,
              description: product.description,
              userData: {
                ...user,
                product,
              },
            });
          });
        });
      });
    }
    const order = await revealData(raw);
    return await status ? order.filter(r => r.status === status) : order;
  } catch (error) {
    return error;
  }
}

export const deleteOrderRequest = async (order) => {
  try {
    await db.ref(`orders/${order.userId}`).child(order.id).remove();
    await db.ref(`orders/${order.targetId}`).child(order.id).remove();
  } catch (error) {
    return error
  }
}

export const addOrderRequest = async (userId, order) => {
  try {
    const getMutualObject = (id) => ({
      date: moment().format('DD-MM-YYYY'),
      time: moment().format('hh:mm'),
      productId: order.product.id,
      quantity: order.quantity,
      status: 'waiting',
      total: order.totalPrice,
      id
    });
    const newRef = await db.ref(`orders/${ userId }/`).push();
    await db.ref(`orders/${ userId }/${ newRef.key }`).set({
      ...getMutualObject(newRef.key),
      targetId: order.targetId,
      userId
    });
    await db.ref(`orders/${ order.targetId }/${ newRef.key }`).set({
      ...getMutualObject(newRef.key),
      userId: order.targetId,
      targetId: userId,
    });
  } catch (error) {
    console.log("addOrderRequest Error: ", error);
  }
}

export const changeOrderStatusRequest = async (order, userId, incomingStatus) => {
 try{
  const { id: orderId, targetId } = order;
  let updateObject = { ...order, status: incomingStatus };
  if(incomingStatus === 'completed') 
    updateObject.completedDate = moment().format('DD-MM-YYYY');
  await db.
    ref(`orders/${targetId}/${orderId}`).update(updateObject);
  await db.
    ref(`orders/${userId}/${orderId}`).update(updateObject);
 } catch(error) {
   console.log("CHANGE ORDER STATUS REQUEST ERROR:" , error)
 }
}

export const getOrdersLength = async (userId, status) => {
  try {
    var ordersLength = [];
    if(status) {
      await db.ref(`orders/${userId}`)
        .orderByChild('status')
        .equalTo(status)
        .once('value', async snap => {
        const orders = await Object.values(snap.val()) ? Object.values(snap.val()) : []
        await ordersLength.push(orders.length)
      });
    } else {
      await db.ref(`orders/${userId}`).once('value', async snap => {
        const orders = await Object.values(snap.val()) ? Object.values(snap.val()) : []
        await ordersLength.push(orders.length)
      });
    }
    return await ordersLength[0].length
  }
    catch(e) {
      console.log(e,' errorrrrr')
    }
}
